
webpack.register(
    'components/dropdown/dropdown-container/dropdown-container',
    function() {
        return require('components/dropdown/dropdown-container/dropdown-container');
    },
    false
);
webpack.register(
    'components/dropdown/dropdown-item/dropdown-item',
    function() {
        return require('components/dropdown/dropdown-item/dropdown-item');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/dropdown/dropdown-container/dropdown-container' />\r\n<can-import from='components/dropdown/dropdown-item/dropdown-item' />\r\n\r\n<div class=\"c-tee-tabs\" id=\"{{uniqueId}}\">\r\n    <dropdown-container {value}=\"currentRound.round.name\" (onChange)=\"onTabChange(%event)\" expand-extra-large expand-large expand-medium>\r\n        {{#each rounds}}\r\n            <dropdown-item analytics-key=\"data-analytics-tt-tab-name\" is-analytics={true} value=\"{{round.name}}\" title=\"{{round.name}}\"></dropdown-item>\r\n        {{/each}}\r\n    </dropdown-container>\r\n</div>");